module.exports = __webpack_public_path__ + "img/consejos-y-trucos.430b6542.png";